import workspaceQuery from 'graphql/queries/diary/DiaryResultWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/diary/DiaryResultListQuery.graphql';
import instanceQuery from 'graphql/queries/diary/DiaryResultQuery.graphql';
import defaultQuery from 'graphql/queries/diary/DiaryResultDefault.graphql';
import mutationQuery from 'graphql/mutations/diary/DiaryResultMutation.graphql';
import fragment from 'graphql/fragments/diary/DiaryResultFragment.graphql';

const DiaryResult = {
  type: 'Result',
  title: 'Task Result Codes',
  formTitle: 'Task Result Code',
  formUrl: '/Diary/Result/Details/',
  workspaceUrl: '/Diary/Result/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'DIARY_EVENT_RESULT_CODES',
};

export default DiaryResult;
